import React from "react";
import "../../landing.css";
import localeText from "../../../../locale";

const steps = [
  {
    number: "1",
    label: "lp2Step1Label",
    icon: "pi pi-shopping-bag",
    title: "lp2Step1Title",
    description: "lp2Step1Desc",
  },
  {
    number: "2",
    label: "lp2Step2Label",
    icon: "pi pi-wallet",
    title: "lp2Step2Title",
    description: "lp2Step2Desc",
  },
  {
    number: "3",
    label: "lp2Step3Label",
    icon: "pi pi-refresh",
    title: "lp2Step3Title",
    description: "lp2Step3Desc",
  },
  {
    number: "4",
    label: "lp2Step4Label",
    icon: "pi pi-shop",
    title: "lp2Step4Title",
    description: "lp2Step4Desc",
  },
];

const LandingComoFunciona = () => {
  return (
    <section className="full-width bg-white py-7">
      <div className="text-center mx-auto px-3 md:px-0" style={{ maxWidth: "680px" }}>
        <div className="eyebrow-text">{localeText("lp2ComoFuncionaEyebrow")}</div>
        <div
          className="font-bold text-4xl md:text-5xl line-height-2 title mt-2"
          style={{ color: "var(--extra-green)" }}
        >
          {localeText("lp2ComoFuncionaTitle")}
        </div>
        <div className="text-lg mt-2" style={{ color: "var(--extra-body)" }}>
          {localeText("lp2ComoFuncionaDescription")}
        </div>
      </div>

      <div className="grid mt-5 py-4">
        {steps.map((step) => (
          <div key={step.number} className="col-12 sm:col-6 lg:col-3">
            <div
              className="landing-card-hover h-full p-4 border-round-lg"
              style={{ backgroundColor: "#fff" }}
            >
              <div
                className="flex align-items-center justify-content-center border-circle mb-3"
                style={{ width: "56px", height: "56px", backgroundColor: "var(--extra-green)" }}
              >
                <i className={step.icon} style={{ color: "#fff", fontSize: "1.4rem" }}></i>
              </div>
              <div className="eyebrow-text" style={{ letterSpacing: "0.1em" }}>
                {step.number}. {localeText(step.label)}
              </div>
              <div className="font-bold text-xl title mt-2" style={{ color: "var(--extra-green)" }}>
                {localeText(step.title)}
              </div>
              <div className="text-sm mt-2" style={{ color: "var(--extra-body)" }}>
                {localeText(step.description)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingComoFunciona;
